import getRoleProperty from '../getRoleProperty';

class ContactRoleNamedInsured {
    constructor() {
        this.$onInit = () => {
            const {fieldValueGetter} = getRoleProperty(this.roleType, this.roleModel, 'namedInsured', 'policyAdditionalNamedInsured');
            this.title = fieldValueGetter(undefined, 'title');
            this.relationshipToPrimaryNamedINsured = fieldValueGetter(undefined, 'relationshipToPrimaryNamedInsured');
        };
    }
}

export default ContactRoleNamedInsured;

